const r=t=>Object.fromEntries(Object.keys(t).filter(e=>!!t[e]).filter(e=>Object.keys(t[e]||{}).length).map(e=>[e,t[e]]));export{r as default};
//# sourceMappingURL=removeEmpty.js.map
